import type { AuthUser } from '@/providers/AuthProvider';

export function needsOnboarding(user: AuthUser): boolean {
  return !user.emailVerifiedAt || !user.hasCnpj;
}

export function resolveNextRoute(user: AuthUser, requestedNext: string | null): string {
  if (needsOnboarding(user)) return '/onboarding';
  if (requestedNext && requestedNext.startsWith('/')) return requestedNext;
  return '/calendar';
}
